// Copyright Epic Games, Inc. All Rights Reserved.

import styled from "styled-components";
import { CircularProgress } from "@material-ui/core";

export const LoadingSpinner = styled(CircularProgress)({
  position: "absolute",
  right: 20,
  top: 7,
});
